export * from './src/ecommerce-currency-converter-v1-currency-rate-currencies.universal.js';
